import { create } from 'zustand';

/**
 * Tiny pub-sub for "the project list is stale, please reload."
 *
 * Components that render a project list (DashboardLayout sidebar, ProjectList
 * grid) include `version` in their load-effect's dependency array; bumping
 * the version triggers a refetch.
 *
 * Mutators (rename, promote draft → active, anything that changes a project's
 * appearance in the list) call `bumpProjectsVersion()` after a successful
 * write. The list components subscribe to `version` and refetch.
 *
 * This intentionally avoids stuffing project concerns into the workspace
 * store and avoids a heavier React Query/SWR migration for now.
 */
interface ProjectsRefreshState {
  version: number;
  bump: () => void;
}

export const useProjectsRefresh = create<ProjectsRefreshState>(set => ({
  version: 0,
  bump: () => set(s => ({ version: s.version + 1 })),
}));

/** Imperative bumper for non-React contexts (e.g. inside async handlers). */
export function bumpProjectsVersion(): void {
  useProjectsRefresh.getState().bump();
}
